import React, { Fragment, PureComponent } from 'react';
import { shopContext } from './contexts/aniplus';
import { Route, withRouter } from 'react-router-dom';
import CacheRoute, { CacheSwitch } from 'react-router-cache-route';
// import { ModalContainer, ModalRoute } from 'react-router-modal';
// import 'react-router-modal/css/react-router-modal.css';

import Main from './pages/Main'; //메인
import Login from './pages/Login'; //로그인
import Logout from './pages/Logout'; //로그인
import Login_ugc from './containers/event/Login_ugc'; //로그인
import Login_recall from './containers/event/Login_recall'; //로그인
import FindAcount from './pages/FindAcount';
import Join from './pages/Join'; //회원가입
import JoinEdit from './pages/JoinEdit'; //회원가입
import Player from './pages/Player'; //플레이어
import LivePlayer from './pages/LivePlayer'; //라이브 플레이어
//import List from "./pages/List";

import Search from './pages/Search';
import TagSearch from './pages/TagSearch';

import Chat from './pages/Chat';
import Ticket from './pages/Ticket';
import Items from './pages/Items';
import My from './pages/My';
import MyPage from './pages/MyPage';
import ProfileEdit from './pages/ProfileEdit';
import Customer from './pages/Customer';

import TimeLineLive from './pages/TimeLineLive';
import TimeLineTv from './pages/TimeLineTv';
import TimelineWeek from './pages/TimelineWeek';
import UpdateWeek from './pages/UpdateWeek';
import Theme from './pages/Theme';
import ThemeList from './pages/ThemeList';

import Card from './pages/Card';
import CardNew from './pages/CardNew';
//import CardReg from "./pages/CardReg";
//import TopMenu from "./menu/TopMenu";
import TopMenuNew from './menu/TopMenuNew';
import TopMenuRe from './menu/TopMenuRe';
import TopMenuMobile from './menu/TopMenuMobile';
import BottomMenuMobile from './menu/BottomMenuMobile';
import QuickMenu from './menu/QuickMenu';

import Dinied from './pages/Dinied';

import Tutorial from './pages/Tutorial';

import MemberShipPayEnd from './pages/MemberShipPayEnd';
import ChannelInfo from './pages/ChannelInfo';
import EventItem from './containers/event/EventItem';

//import Setting from "./pages/Setting";
import SettingNew from './pages/SettingNew';
import PriceAgree from './pages/PriceAgree';
import Poll from './pages/Poll';
import FriendAdd from './pages/FriendAdd';

import BoardDetail from './pages/BoardDetail';
import AttackOnTitan from './pages/AttackOnTitan';

import Error404 from './pages/Error404';
//import Soon from './pages/Soon'

import FriendCode from './pages/FriendCode';

import Event from './pages/Event';

import GuestBook from './pages/GuestBook';
import GuestBookTablet from './pages/GuestBookTablet';

import Store from './pages/Store';
import StoreWrite from './containers/store/StoreWrite';
//import StoreEdit from './containers/store/StoreEdit';
import StoryItem from './containers/store/StoryItem';
import StoreInfo from './containers/store/StoreInfo';
import StoreOriginalGoods from './containers/store/StoreOriginalGoods';
import StoreCollaboCafe from './containers/store/StoreCollaboCafe';
import StoreLottery from './containers/store/StoreLottery';

import Reserve from './pages/Reserve';
import ReserveDetail from './pages/ReserveDetail';
import ReserveList from './pages/ReserveList';
import ReserveFail from './pages/ReserveFail';
import Tsucc from './pages/Tsucc';
import Tfail from './pages/Tfail';

import CollaboReserve from './pages/CollaboReserve';
import CollaboReserveDetail from './pages/CollaboReserveDetail';
import CollaboReserveList from './pages/CollaboReserveList';
import Rsucc from './pages/Rsucc';
import Rfail from './pages/Rfail';

import { Modal } from 'react-responsive-modal';
import { ToastContainer } from 'react-toastify'; //토스트(toast)
//import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)

import axios from 'axios';
import { isMobile, isAndroid, isIOS } from 'react-device-detect';

//import PayTest from "./pages/PayTest";
//import Seat from "./pages/Seat";

import { Helmet } from 'react-helmet-async';
import Event2022_aketo from './containers/event/Event2022_aketo';

import NoticePopup from './pages/NoticePopup';

// import Kaiju from './pages/Kaiju';
import ChatBot from './pages/ChatBot';
// import Test from './pages/Test';

// import EventTicket from './containers/event/Ticket';
import moment from 'moment';

// import Queue from './pages/Queue';
import Seat from './pages/Seat';
import SeatReserve from './pages/SeatReserve';
import SeatSucc from './pages/SeatSucc';
import SeatFail from './pages/SeatFail';
import SeatReservePay from './pages/SeatReservePay';
import SeatReserveBarcode from './pages/SeatReserveBarcode';

import Redis from './pages/Redis';
// import SeatPop from './pages/SeatPop';

// import Vod from './pages/Vod';

class App extends PureComponent {
  state = {
    popupShow: false,
    serviceEndDate: '2024-12-31 23:59:59',
  };
  componentDidMount = () => {
    const { history } = this.props;
    // this.getIpInfo();
    // const notice = this._getCookie('notice');
    // console.log(notice);
    // if (!notice) {
    //   this.setState({
    //     popupShow: history.location.pathname === '/event/333' ? false : true,
    //   });
    // }
  };

  getIpInfoApi = () => {
    const { apiUrl } = this.props;
    //console.log('aaaaaaaaaaaaa')
    return axios
      .post(apiUrl + '/geoip', {
        params: {},
      })
      .then((response) => response)
      .catch((error) => {
        //alert('오류가 발생했습니다.')
      });
  };
  getIpInfo = async () => {
    const { history } = this.props;
    const result = await this.getIpInfoApi();

    const data = result.data[0].listData;
    const ip = result.data[0].ip;
    // console.log(ip);
    if (
      ip === '202.214.96.1' ||
      ip === '202.214.96.34' ||
      ip === '202.214.96.35' ||
      ip === '202.214.96.64' ||
      ip === '202.214.96.65' ||
      ip === '202.214.96.66' ||
      ip === '202.214.96.67' ||
      ip === '202.214.96.68' ||
      ip === '202.214.96.69' ||
      ip === '202.214.96.70' ||
      ip === '202.214.96.71' ||
      ip === '202.214.96.72' ||
      ip === '202.214.96.73' ||
      ip === '202.214.96.74' ||
      ip === '202.214.96.75' ||
      ip === '202.214.96.76' ||
      ip === '202.214.96.77' ||
      ip === '202.214.96.78' ||
      ip === '202.214.96.79' ||
      ip === '202.214.96.80' ||
      ip === '202.214.96.81' ||
      ip === '202.214.96.82' ||
      ip === '202.214.96.83' ||
      ip === '202.214.96.84' ||
      ip === '202.214.96.85' ||
      ip === '202.214.96.86' ||
      ip === '202.214.96.87' ||
      ip === '202.214.96.88' ||
      ip === '202.214.96.89' ||
      ip === '202.214.96.90' ||
      ip === '202.214.96.91' ||
      ip === '202.214.96.92' ||
      ip === '202.214.96.93' ||
      ip === '202.214.96.94' ||
      ip === '202.214.96.95'
    ) {
      if (
        moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
        '2026-07-31 23:59:59'
      ) {
        history.push('/dinied');
      }
      //사이게임즈 고정 아이피 (해외 접속 예외 처리)
      //2024년 8월 18일까지.
    } else {
      if (data.country === 'KR') {
        //history.push('/dinied')
      } else {
        history.push('/dinied');
      }
    }

    /*
      axios.get("http://ip-api.com/json").then(response => {
          let data = response.data || {};
          //console.log(data)
        
          if(data.countryCode === 'KR') {
            //history.push('/dinied')
          } else {
            history.push('/dinied')
          }


      }).catch((err) => {
         
      });
      */
  };
  _setCookie = (name, value, exp) => {
    let expires;
    if (exp) {
      var date = new Date();
      date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
      expires = date.toGMTString();
    } else {
      expires = '';
    }
    document.cookie =
      name +
      '=' +
      value +
      ';expires=' +
      expires +
      ';path=/; domain=aniplustv.com';
  };
  _getCookie = (name) => {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return value ? value[2] : null;
  };

  _popupClose = (checked) => {
    //쿠키 생성

    const value = this._getCookie();
    //console.log(checked);
    if (checked) {
      this._setCookie('notice', true, 7);
    }
    this.setState({
      popupShow: false,
    });
  };
  render() {
    //const { ip, country } = this.state;
    //const country = "JP"
    const {
      history,
      contentSerial,
      playUrl,
      timeline,
      tvline,
      cardRegShow,
      cardListShow,
      memberShipPayEnd,
      orderCode,
      channelShow,
      updateShow,
      eventIdx,
      tutorialShow,
      settingShow,
      agreeShow,
      pollIdx,
      board_idx,
      timelineWeek,
      showFriend,
    } = this.props;
    const { popupShow, serviceEndDate } = this.state;
    //console.log(history)
    //console.log(playUrl)
    // console.log(history.location.pathname.indexOf('/reserve/'));
    const today = moment(new Date());
    return (
      <Fragment>
        <Helmet>
          <title>한일 동시방영 채널 - 애니플러스</title>
          <meta name="robots" content="index,follow" />
          <meta
            name="title"
            content="한일 동시 방영 애니메이션 채널 - 애니플러스"
          />
          <meta
            name="description"
            content="가장 빠른 한일 동시 방영 채널. 분기별 최신 신작을 일본과 동시에 방영하는 라이브, 스파이 패밀리, 진격의 거인, 주술회전등 인기작품 고화질 무제한 스트리밍, 다운로드, 굿즈 판매. "
          />
          <meta
            name="keywords"
            content="나혼랩, 나혼자만 레벨업, 스파이 패밀리, 진격의 거인, 주술회전, 뱅드림, 러브라이브, 바니스타의 수기, 애니, 애니메이션, 스트리밍, 라이브, 다운로드, 동시방영, 애니플러스"
          />

          <meta property="og:type" content="website" />
          <meta
            property="og:title"
            content="한일 동시 방영 애니메이션 채널 - 애니플러스"
          />
          <meta
            property="og:description"
            content="가장 빠른 한일 동시 방영 채널. 분기별 최신 신작을 일본과 동시에 방영하는 라이브, 스파이 패밀리, 진격의 거인, 주술회전등 인기작품 고화질 무제한 스트리밍, 다운로드, 굿즈 판매."
          />
          <meta property="og:url" content="https://www.aniplustv.com" />
          <meta
            property="og:image"
            content="https://www.aniplustv.com/mobile/img/event_0518.png"
          />

          <meta name="twitter:card" content="summary" />
          <meta
            name="twitter:title"
            content="한일 동시 방영 애니메이션 채널 - 애니플러스"
          />
          <meta
            name="twitter:description"
            content="가장 빠른 한일 동시 방영 채널. 분기별 최신 신작을 일본과 동시에 방영하는 라이브, 스파이 패밀리, 진격의 거인, 주술회전등 인기작품 고화질 무제한 스트리밍, 다운로드, 굿즈 판매."
          />
          <meta name="twitter:domain" content="https://www.aniplustv.com" />
          <meta
            property="twitter:image"
            content="https://www.aniplustv.com/mobile/img/event_0518.png"
          />
          <link rel="canonical" href="https://www.aniplustv.com" />
        </Helmet>

        <div
          id={history.location.pathname === '/chatbot' ? '' : 'root'}
          className={
            history.location.pathname.indexOf('/store') > -1 ||
            history.location.pathname === '/reserve' ||
            history.location.pathname === '/cr' ||
            history.location.pathname.indexOf('/reserve') > -1 ||
            history.location.pathname.indexOf('/story') > -1
              ? 'style_v2 theme_lt'
              : history.location.pathname === '/chatbot'
                ? ''
                : 'style_v2'
          }
        >
          {history.location.pathname === 'error-404' ||
          history.location.pathname === '/gb' ||
          history.location.pathname === '/gbt' ||
          history.location.pathname === '/player/' ||
          history.location.pathname === '/login' ||
          history.location.pathname === '/login_ugc' ||
          history.location.pathname === '/login_recall' ||
          history.location.pathname === '/join' ||
          history.location.pathname === '/edit' ||
          history.location.pathname === '/find' ||
          history.location.pathname === '/timelinelive' ||
          history.location.pathname === '/dinied' ||
          history.location.pathname === '/reserve' ||
          history.location.pathname === '/cr' ||
          history.location.pathname === '/crlist' ||
          history.location.pathname.indexOf('/reserve') > -1 ||
          history.location.pathname.indexOf('/cr') > -1 ||
          history.location.pathname.indexOf('/s/') > -1 ||
          history.location.pathname === '/paytest' ||
          history.location.pathname === '/seatReservePay' ||
          history.location.pathname === '/chatbot' ||
          history.location.pathname === '/seatPop' ? null : (
            <Fragment>
              {history.location.pathname.indexOf('/event/') > -1 ? (
                isMobile ? (
                  <Fragment>
                    {isMobile ? (
                      <>
                        <TopMenuMobile />
                        <BottomMenuMobile />
                      </>
                    ) : (
                      <TopMenuRe />
                    )}
                  </Fragment>
                ) : (
                  <Fragment>
                    {isMobile ? (
                      <>
                        <TopMenuMobile />
                        <BottomMenuMobile />
                      </>
                    ) : (
                      <TopMenuRe />
                    )}
                  </Fragment>
                )
              ) : history.location.pathname.indexOf('/store') > -1 ? (
                <Fragment>
                  {isMobile ? (
                    <>
                      <TopMenuMobile />
                      <BottomMenuMobile />
                    </>
                  ) : (
                    <TopMenuRe />
                  )}
                </Fragment>
              ) : isMobile ? (
                <Fragment>
                  {isMobile ? (
                    <>
                      <TopMenuMobile />
                      <BottomMenuMobile />
                    </>
                  ) : (
                    <TopMenuRe />
                  )}
                </Fragment>
              ) : (
                <Fragment>
                  {isMobile ? (
                    <>
                      <TopMenuMobile />
                      <BottomMenuMobile />
                    </>
                  ) : (
                    <TopMenuRe />
                  )}
                </Fragment>
              )}
            </Fragment>
          )}
          {/**/}

          {timeline ? <TimeLineLive /> : null}
          {tvline ? <TimeLineTv /> : null}
          {timelineWeek ? <TimelineWeek /> : null}
          {updateShow ? <UpdateWeek /> : null}
          {showFriend ? <FriendAdd /> : null}
          {contentSerial === 0 ? null : <Items contentSerial={contentSerial} />}

          {eventIdx === 0 ? null : <EventItem eventIdx={eventIdx} />}

          {board_idx === 0 ? null : <BoardDetail board_idx={board_idx} />}

          {playUrl === '' ||
          playUrl === null ||
          playUrl === undefined ? null : (
            <Player u={playUrl} />
          )}
          {cardRegShow ? <CardNew index={1} /> : null}

          {cardListShow ? <CardNew index={0} /> : null}

          {settingShow ? <SettingNew /> : null}

          {agreeShow ? <PriceAgree /> : null}

          {pollIdx > 0 ? <Poll /> : null}

          {memberShipPayEnd ? (
            orderCode ? (
              <MemberShipPayEnd orderCode={orderCode} />
            ) : null
          ) : null}

          {tutorialShow ? <Tutorial /> : null}

          <Modal
            open={channelShow}
            showCloseIcon={false}
            closeOnOverlayClick={true}
            closeOnEsc={true}
            center
            styles={{
              modal: {
                backgroundColor: 'black',
                width: '100%',
                height: '100%',
              },
            }}
          >
            <ChannelInfo />
          </Modal>
          <Modal
            open={popupShow}
            showCloseIcon={false}
            closeOnOverlayClick={true}
            closeOnEsc={true}
            center
            styles={{
              modal: {
                backgroundColor: 'black',
                // width: '100%',
                // height: '100%',
              },
            }}
          >
            <NoticePopup popupClose={this._popupClose} />
          </Modal>

          {/*CacheRoute*/}
          <CacheSwitch>
            {/*<Route exact path="/" component={Main} />*/}

            {/* <CacheRoute
              exact
              path="/"
              component={
                moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >=
                  '2024-04-11 17:00:00' &&
                moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <=
                  '2024-04-11 18:10:00'
                  ? Kaiju
                  : Main
              }
              when="aways"
              cacheKey="main"
            /> */}

            <CacheRoute
              exact
              path="/"
              component={Main}
              when="aways"
              cacheKey="main"
            />

            <Route exact path="/login" component={Login} />
            {/* <Route exact path="/logout" component={Logout} /> */}
            <Route exact path="/login_ugc" component={Login_ugc} />
            <Route exact path="/login_recall" component={Login_recall} />
            <Route exact path="/join" component={Join} />
            <Route exact path="/edit" component={JoinEdit} />
            <Route exact path="/find" component={FindAcount} />
            <Route exact path="/player" component={Player} />

            {moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >
            '2024-12-31 23:59:59' ? null : (
              <Route exact path="/live" component={LivePlayer} />
            )}

            {/*<CacheRoute exact path="/live" component={LivePlayer}  when="back" />*/}

            {/*<Route exact path="/Search" component={Search} />*/}
            <CacheRoute exact path="/Search" component={Search} when="aways" />

            {/*<Route exact path="/list" component={TagSearch} />*/}
            <CacheRoute
              exact
              path="/list"
              component={TagSearch}
              when="always"
            />

            <Route exact path="/chat" component={Chat} />
            <Route exact path="/ticket" component={Ticket} />
            <Route exact path="/my/:index" component={My} />

            <Route exact path="/mypage/:menu" component={MyPage} />

            <Route exact path="/profile" component={ProfileEdit} />
            <Route exact path="/customer/:index" component={Customer} />

            <Route exact path="/items/:contentSerial" component={Items} />

            <Route exact path="/event/:eventIdx" component={EventItem} />

            <Route exact path="/timelinelive" component={TimeLineLive} />
            <Route exact path="/timelinetv" component={TimeLineTv} />
            <Route exact path="/card" component={Card} />

            {/*<Route exact path="/theme" component={Theme} />*/}
            <CacheRoute exact path="/theme" component={Theme} when="always" />

            {/*<Route exact path="/tlist" component={ThemeList} />*/}
            <CacheRoute
              exact
              path="/tlist"
              component={ThemeList}
              when="always"
            />

            <Route exact path="/titan" component={AttackOnTitan} />
            <Route exact path="/fcode" component={FriendCode} />

            <Route exact path="/event" component={Event} />

            <Route path="/error-404" component={Error404} />
            <Route exact path="/dinied" component={Dinied} />

            <Route exact path="/gb" component={GuestBook} />
            <Route exact path="/gbt" component={GuestBookTablet} />

            {/*스토어 관련 라우터 */}

            <Route exact path="/store" component={Store} />
            <Route exact path="/storeWrite" component={StoreWrite} />
            <Route exact path="/storyItem/:store/:idx" component={StoryItem} />
            <Route exact path="/storeInfo/:store" component={StoreInfo} />
            <Route
              exact
              path="/storeOriginalGoods"
              component={StoreOriginalGoods}
            />
            <Route
              exact
              path="/storeCollaboCafe"
              component={StoreCollaboCafe}
            />
            <Route exact path="/storeLottery" component={StoreLottery} />
            <Route exact path="/aketo" component={Event2022_aketo} />

            <Route exact path="/reserve" component={Reserve} />
            <Route exact path="/reserve/:orderCode" component={ReserveDetail} />
            <Route exact path="/reserveList" component={ReserveList} />
            <Route exact path="/reserveFail" component={ReserveFail} />
            <Route exact path="/tsucc" component={Tsucc} />
            <Route exact path="/tfail" component={Tfail} />

            {/* 콜라보 카페 예약 */}
            <Route exact path="/cr" component={CollaboReserve} />
            <Route
              exact
              path="/cr/:orderCode"
              component={CollaboReserveDetail}
            />
            <Route exact path="/crlist" component={CollaboReserveList} />
            <Route exact path="/rsucc" component={Rsucc} />
            <Route exact path="/rfail" component={Rfail} />
            {/* 콜라보 카페 예약 */}

            <Route exact path="/chatbot" component={ChatBot} />
            {/* <Route exact path="/test" component={Test} /> */}

            {/* <Route exact path="/queue" component={Queue} /> */}
            <Route exact path="/seatLove2" component={Seat} />
            <Route exact path="/seatSucc" component={SeatSucc} />
            <Route exact path="/seatFail" component={SeatFail} />
            <Route exact path="/seatReservePay" component={SeatReservePay} />
            <Route exact path="/s/:p" component={SeatReserveBarcode} />
            <Route exact path="/redis" component={Redis} />
            {/* <Route exact path="/seatPop" component={SeatPop} /> */}

            {/* <Route path="/testModal" component={Vod} /> */}
            <Route component={Error404} />
            <Route path="/" component={Error404} />

            {/*<Redirect to="/error-404" />*/}
          </CacheSwitch>

          {/*<Route exact path="/tut" component={Tutorial} />*/}

          <ToastContainer
            autoClose={4000}
            position="bottom-right"
            hideProgressBar={false}
          />

          {/* <ModalContainer
            // backdropClassName="modal_drop"
            // modalClassName="modal_main"
            // bodyModalOpenClassName="modal_drop"
            // containerClassName="modal_container"
          /> */}
        </div>
      </Fragment>
    );
  }
}
export default shopContext(withRouter(App));
